import { ACCOUNT_STATUS_TYPE, ActionType } from "../ChatAction";

export default function setAccountStatus(status: ACCOUNT_STATUS_TYPE): ActionType {
    return {
        type: "account_status",
        detail: {
            status,
            timestamp: +new Date()
        }
    };
}